/* eslint-disable no-nested-ternary */
import { Box } from '@mui/material'
import { useEffect, useRef } from 'react'
import {
    LazyComponentProps,
    trackWindowScroll,
} from 'react-lazy-load-image-component'
import 'swiper/css'
import 'swiper/css/navigation'
import { useVODStore } from '@/shared/store'
import { continueWatchingKeyword } from '@/shared/constants'
import { useVodItemsContext } from '@/features/VOD/context/UseGetVodItemContext/useVodItemsContext'
import { ZeroRowVodSlider } from '@/clients/streamiq/features/VOD/components/ZeroRowVodSlider'
import { pageType } from '@/shared/store/types'

export interface ZeroRowViewProps extends LazyComponentProps {
    productId: number | string
    handleGoToCategoryButtonClick: (
        itemId: string,
        title: string,
        type: pageType
    ) => void
    maxHeight: number
    atmosphericUrl?: string
    isSkeletons?: boolean
    rowHeightPercentage?: number
    cardRadiusDp?: number
    hideCaptions?: boolean
    hideProgress?: boolean
    isHomeContentRow?: boolean
    query?: string
}

const ZeroRowView = ({
    productId,
    handleGoToCategoryButtonClick,
    scrollPosition,
    maxHeight,
    hideCaptions,
    hideProgress,
    cardRadiusDp,
    rowHeightPercentage,
    isHomeContentRow,
}: ZeroRowViewProps) => {
    const itemsContainerRef = useRef<HTMLDivElement>(null)
    const vodItemHeight = maxHeight

    const { rowItems, getItems } = useVodItemsContext()

    const { isFetchContinuesWatching, setIsFetchContinuesWatching } =
        useVODStore()

    useEffect(() => {
        const rowElement = itemsContainerRef.current

        if (rowElement) {
            rowElement.addEventListener('scroll', () => getItems())
            return () =>
                rowElement.removeEventListener('scroll', () => getItems())
        }
    }, [])

    useEffect(() => {
        if (isFetchContinuesWatching && productId === continueWatchingKeyword) {
            getItems(continueWatchingKeyword)
            setIsFetchContinuesWatching(false)
        }
    }, [isFetchContinuesWatching])

    const rowViewContainerStyle = {
        position: 'relative',
        // width: '99%',
    }

    if (!rowItems) return <></>

    return (
        <Box onScroll={() => getItems()} sx={rowViewContainerStyle}>
            <ZeroRowVodSlider
                buttonHeight={
                    rowHeightPercentage
                        ? (rowHeightPercentage / 100) * vodItemHeight
                        : vodItemHeight
                }
                hideCaptions={hideCaptions}
                hideProgress={hideProgress}
                vodItemHeight={vodItemHeight}
                cardRadiusDp={cardRadiusDp}
                rowHeightPercentage={rowHeightPercentage}
                handleGoToCategoryButtonClick={handleGoToCategoryButtonClick}
                scrollPosition={scrollPosition}
                isHomeContentRow={isHomeContentRow}
            />
        </Box>
    )
}

export default trackWindowScroll(ZeroRowView)
